import { types, getEnv, applySnapshot, Instance, getRoot } from 'mobx-state-tree';
import { createContext, useContext } from 'react';

import { clear } from '../../libs/storage';
import { MobxEnvironment } from '../../core/mobx-environment';
import { ROOT_STATE_STORAGE_KEY } from '../../core/mobx-constants';
import { NavigationStoreModel } from './NavigationStore';
import { DigitalOrdersStoreModel } from './DigitalOrdersStore';
import { ConfigStoreModel } from './ConfigStore';
import { AuotmationStoreModel } from './AutomationStore';

export const RootStoreModel = types
  .model('RootStore')
  .props({
    automationStore: types.optional(AuotmationStoreModel, {}),
    navigationStore: types.optional(NavigationStoreModel, {}),
    digitalOrdersStore: types.optional(DigitalOrdersStoreModel, {}),
    configStore: types.optional(ConfigStoreModel, {}),
  })
  .views(self => ({
    get environment() {
      return getEnv(self) as MobxEnvironment;
    },
    get rootStore() {
      return getRoot(self);
    },
  }))
  .actions(self => ({
    reset: () => {
      clear([ROOT_STATE_STORAGE_KEY]);
      applySnapshot(self, {});
    },
  }));

export type RootInstance = Instance<typeof RootStoreModel>;
const RootStoreContext = createContext<null | RootInstance>(null);

export const Provider = RootStoreContext.Provider;
export function useMst() {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error('Store cannot be null, please add a context provider');
  }
  return store as RootInstance;
}
